const invoiceFilters = {
  clientId: null,
  postingStateId: null,
  submittedFrom: null,
  submittedTo: null
}

export default () => Object.assign({}, invoiceFilters)
